module.exports = __webpack_public_path__ + "static/img/14.b1704c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/14.png
// module id = u5dc
// module chunks = 0